export default __webpack_public_path__ + "static/media/skyrider_greatsword.46e935cb.png";